"use client";
import useInteractionStart from "@/hooks/useInteractionStart";
import React from "react";

export const CategoriesSkeleton: React.FC<{ minHeight?: number }> = ({
  minHeight = 140,
}) => {
  const { isInteracting } = useInteractionStart();
  return (
    <div style={{ minHeight, width: "100%" }}>
      {!isInteracting && (
        <div className="skeleton-rect" style={{ width: "100%", height: "100%" }} />
      )}
    </div>
  );
};

export const BlogsSkeleton: React.FC = () => {
  const { isInteracting } = useInteractionStart();
  
  if (isInteracting) {
    return <div style={{ height: 36, margin: "24px 0" }} />;
  }

  const items = Array.from({ length: 3 });
  return (
    <>
      <div style={{ height: 36, margin: "24px 0" }} className="skeleton-rect" />
      <div className="Embla-Slider-viewport">
        <ul
          className="Embla-Slider-container"
          style={{
            gap: 24,
            width: "100%",
            margin: 0,
            padding: 0,
            listStyleType: "none",
          }}
        >
          {items.map((_, i) => (
            <li key={i} style={{ flex: "0 0 auto", maxWidth: "100%" }}>
              <div className="builder-blog">
                <div
                  className="blog-img-container"
                  style={{ width: 304, height: 160 }}
                >
                  <div
                    className="skeleton-rect"
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                <div className="text-conainer" style={{ marginTop: 8 }}>
                  <div className="skeleton-text" />
                  <div className="skeleton-text" />
                  <div className="skeleton-text" />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
